<template>


  <v-card class="card" width="44em" maxWidth="90vw" align="center" rounded="xl">

    <v-img src="/assets/online.svg" width="3em" height="3em" class="mt-8"/>

    <v-card-text>
      <strong style="font-size: 1.5em;">{{ $t('wait.welcome') }}</strong>
      <br />
      <hr class="ma-3" style="color:#e1e628; width: 20em; border: 0.2em solid" />
      <Transition name="bounce">
        <div v-if="meetingNotFound">
          {{ $t('wait.notFound') }}
        </div>
      </Transition>
      <transition name="bounce" >
        <div v-if="clientMeeting">
          <hr class="ma-4" style="color:#e4e4e4; border: 0.1em solid" />
          <strong>{{ $t('wait.advisedBy') }}</strong>
          <v-img :src="imageUrl" height="14em" width="14em" class="counselor ma-2"/>
          <strong>{{ clientMeeting.counselorName }}</strong>
          <div v-if="showJoin" class="mt-4" align="center" justify="center">
            <table border="0">
              <tr>
                <td>
                  <div v-html="$t('wait.ready')">
                  </div>
                </td>
                <td>
                  <v-img src="/assets/check.png" width="2em" />
                </td>
              </tr>
            </table>
            <div class="button mt-3" >
              <a style="width: 15em;" :onClick="joinCounseling">{{ $t('wait.start') }}</a>
            </div>
          </div>
          <div v-else>
            {{ $t('wait.wait') }} <v-progress-circular class="ma-2" size="24" width="1" color="gray" indeterminate />
          </div>
        </div>
      </transition>

      <transition name="bounce">
        <div v-if="counselorMeeting">
          <v-table>
            <thead>
              <tr>
                <th class="text-left">
                  <strong>{{ $t('wait.client') }}</strong>
                </th>
                <th class="text-left">
                  <strong>{{ $t('wait.waitingRoom') }}</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in counselorMeeting.participants" v-bind:key="item.id">
                <td>{{ item.mail }}</td>
                <td>
                  <v-tooltip v-if="item.seen" :text="$t('wait.clientSeen')">
                    <template v-slot:activator="{ props }">
                      <v-img v-bind="props" src="/assets/user_check.svg" width="2em" />
                    </template>
                  </v-tooltip>
                  <v-tooltip v-else :text="$t('wait.clientNotSeen')">
                    <template v-slot:activator="{ props }">
                      <v-img v-bind="props" src="/assets/user_x.svg" width="2em" />
                    </template>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </v-table>
          <br />
          <div class="button mt-3" >
            <a style="width: 15em;" :onClick="startCounseling">{{ $t('wait.start') }}</a>
          </div>
        </div>
      </transition>
      <transition name="bounce">
        <div v-if="loading" class="ma-4">
        {{ $t('app.loading') }}
        <br />
        <v-progress-circular class="ma-2" :width="1" color="green" indeterminate />
      </div>
      </transition>
    </v-card-text>
  </v-card>

  <NextSteps v-if="!meetingNotFound" class="mt-8"/>
  
  <v-snackbar color="red" location="top" v-if="message" v-model="message">
      {{ message }}
    <template v-slot:actions>
      <v-btn variant="text" @click="message = null">
        X
      </v-btn>
    </template>
  </v-snackbar>

</template>

<script>

import { ref } from 'vue'
import { useRoute } from 'vue-router'
import instantmeetingservice from "@/services/instantmeetingservice";
import NextSteps from './NextSteps.vue';

export default {
  name: 'WaitForCounselor',
  components: {
    NextSteps
  },
  setup: () => {
    const route = useRoute();
    const meetingId = route.params.id;
    const text = ref(null)
    return { meetingId, text }
  },
  mounted() {
    this.load();
  },
  created() {
    this.$watch(() => this.$i18n.locale, () => {
      if (!this.localChangedByCode) {
        this.loading = true;
        this.meeting = null;
        this.counselorMeeting = null;
        this.clientMeeting = null;
        this.load(false);
      }
      this.localChangedByCode = false;
    })
  },
  data: () => ({
    loading: true,
    boxClass: "box",
    arrowClass: "arrow",
    meetingNotFound: false,
    intervalId: null,
    meeting: null,
    clientMeeting: null,
    counselorMeeting: null,
    message: null,
    showJoin: false,
    localChangedByCode: false,
    imageUrl: "/assets/woman_placeholder.svg"
  }),
  computed: {
    showMore: function() {
      if (this.text) {
        return (this.text.offsetWidth < this.text.scrollWidth) || (this.text.offsetHeight < this.text.scrollHeight);
      }
      return false;
    }
  },
  methods: {
    createUpdateTimer() {
      if (this.intervalId) clearInterval(this.intervalId);
      this.intervalId = setInterval(this.load, 2000);
    },
    stopUpdateTimer() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      } 
    },
    startCounseling() {
      window.location.replace(this.counselorMeeting.url);
    },
    joinCounseling() {
      window.location.replace(this.clientMeeting.url);
    },
    showNotFound() {
      this.stopUpdateTimer();
      this.meetingNotFound = true;
    },
    changeLocale(lang) {
      if (localStorage.getItem('lang') != lang) {
        this.localChangedByCode = true;
        localStorage.setItem('lang', lang);
        this.$i18n.locale = lang;
        this.showLanguages = false;
      }
    },
    showMoreText() {
      if (this.boxClass=='box') {
        this.boxClass = 'box open'
        this.arrowClass = 'arrow open'
      } else {
        this.boxClass = 'box'
        this.arrowClass = 'arrow'
      }
    },
    load(changeLocale = true) {
        instantmeetingservice.get(this.meetingId).then(meeting => {
          if (this.meeting) {
            this.meeting.participants = meeting.participants;
            this.meeting.status = meeting.status;
          } else {
            this.meeting = meeting
            this.imageUrl = meeting.counselorImageUrl
            if (meeting.memberType=="COUNSELOR") this.counselorMeeting = meeting;
            else this.clientMeeting = meeting;
            if (changeLocale)
            this.changeLocale(meeting.language.isoName);
          }
          this.loading = false;
          this.showJoin = this.clientMeeting && this.clientMeeting.status=="CREATED";
          this.createUpdateTimer();
        }, (error) => {
          this.loading = false;
          if (error.response.status==404) this.showNotFound();
          else this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          })
    },

  }

}
</script>

<style scoped>
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}

strong {
  font-family: "Nunito Sans ExtraBold";
}

.counselor {
  border-radius: 2em;
  overflow: hidden;
}

.yline {
  border: 0.2em;
  border-radius: .2em;
  overflow: hidden;
}

.card {
  padding-left: 10em;
  padding-right: 10em;
}

@media screen and (max-width:767px) {
  .card {
    padding-left: 0.25em;
    padding-right: 0.25em;
  }

}

/* Box */
.box {
  max-height: 7em;
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(0, 1, 0, 1);
}

.box.open {
  max-height: 100rem;
  transition: max-height 0.3s cubic-bezier(0.9, 0, 0.8, 0.2);
}

/* Text */
@keyframes open {
  from {
    line-clamp: 3;
    -webkit-line-clamp: 3;
  }
  to {
    line-clamp: initial;
    -webkit-line-clamp: initial;
  }
}

@keyframes close {
  from {
    line-clamp: initial;
    -webkit-line-clamp: initial;
  }
  to {
    line-clamp: 3;
    -webkit-line-clamp: 3;
  }
}

.text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  animation: close 0.1s linear 0.1s forwards;
}
.open .text {
  animation: open 0.1s linear 0s forwards;
}

/* Irrelavant css... */
.arrow {
  border: solid #000;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 4px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  margin-right: 2em;
}

.open .arrow {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  margin-top: 5px;
  margin-right: 2em;
}

</style>